<template>
  <SensorDetailDialog
    :isShowDetail.sync="detailIsShow"
    :title="detailTitle"
    :baseMsg="baseMsg"
    :detailObj="detailObj"
    :deviceType="newDeviceType"
    :deviceProperty="deviceProperty"
    :detailLoading="detailLoading"
    :detailRuleObj="detailRuleObj"
    :detailNetObj="detailNetObj"
    :detailData="detailData"
    :calibrationInfo="calibrationInfo"
    :locationList="locationList"
    :groupList="groupList"
    v-bind="$attrs"
    class="comp-sensor-detail"
  ></SensorDetailDialog>
</template>

<script>
import SensorDetailDialog from './component/SensorDetailDialog.vue'
import { sensorGetSensorDetailInfo, getCalibrationInfo } from '@/api/modules/sensor.js'
import { getLocationList, getGroupList } from '@/api/modules/public.js'
import bus from '@/utils/bus'

export default {
  props: {
    id: {},
    name: {},
    show: {}
  },
  components: {
    SensorDetailDialog
  },
  data () {
    return {
      detailData: null,
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url',
          content: ''
        },
        {
          text: $t('integration.mount_'),
          key: 'carrierName',
          content: ''
        },
        {
          text: $t('integration.sensor_number'),
          key: 'tagId',
          content: ''
        },
        {
          text: $t('integration.sensor_type'),
          key: 'type',
          content: ''
        },

        {
          text: $t('integration.sensor_status'),
          key: 'status',
          content: ''
        },
        {
          text: 'device.config_status',
          key: 'configStatus',
          content: ''
        },
        {
          text: 'public.table_create_time',
          key: 'createTime',
          content: ''
        },
        {
          key: 'location',
          text: $t('public.location_desc'),
          content: ''
        },
        {
          key: 'group',
          text: $t('public.group_desc'),
          content: ''
        },
        {
          key: 'nickname',
          text: 'device.nickname',
          content: ''
        },
        {
          key: 'description',
          text: $t('public.table_desc'),
          content: ''
        },

      ],
      detailRuleObj: [
        {
          key: 'collectInterval',
          text: $t('device.sample_interval'),
          isBool: true
        },
        {
          key: 'exCollectInterval',
          text: $t('device.exception_sample_interval'),
          isBool: true
        },
        {
          key: 'tempCollectInterval',
          text: $t('integration.temperature_acquisition_interval'),
          isBool: true
        },
        {
          key: 'tempChange',
          text: $t('integration.temperature_change_threshold'),
          isBool: true
        },
        {
          key: 'tempMaxReport',
          text: $t('integration.maximum_temperature_reporting_interval'),
          isBool: true
        },
        {
          key: 'tempMinReport',
          text: $t('integration.minimum_temperature_reporting_interval'),
          isBool: true
        },

        {
          key: 'humCollectInterval',
          text: $t('integration.humidity_collection_interval'),
          isBool: true
        },
        {
          key: 'humChange',
          text: $t('integration.humidity_change_threshold'),
          isBool: true
        },
        {
          key: 'humMaxReport',
          text: $t('integration.maximum_humidity_reporting_interval'),
          isBool: true
        },
        {
          key: 'humMinReport',
          text: $t('integration.humidity_minimum_reporting_interval'),
          isBool: true
        }
        // {
        //   key: 'monitor_mode',
        //   text: '工作模式',
        //   isBool: true
        // },
        // {
        //   key: 'sample_gap',
        //   text: '采集间隔'
        // },
        // {
        //   key: 'max_rec_gap',
        //   text: '最大记录间隔'
        // },
        // {
        //   key: 'min_rec_gap',
        //   text: '最小记录间隔'
        // },
        // {
        //   key: 'change_threshold',
        //   text: '最大变化量'
        // },
        // {
        //   key: 'nor_rep_gap',
        //   text: '正常采集间隔'
        // },
        // {
        //   key: 'abnor_rep_gap',
        //   text: '异常采集间隔'
        // },
        // {
        //   key: 'sync_interval',
        //   text: '同步采集间隔'
        // },
        //
        // {
        //   key: 'sample_mode',
        //   text: '采集模式'
        // },
        // {
        //   key: 'normal_report_interval',
        //   text: '正常上报间隔'
        // },
        // {
        //   key: 'abnormal_report_intervals',
        //   text: '异常上报间隔'
        // },
        // {
        //   key: 'sync_interval',
        //   text: '同步采集间隔'
        // },
        // {
        //   key: 'gap_interval',
        //   text: '固定采集间隔'
        // }
      ],
      detailNetObj: [
        {
          key: 'extPanId',
          text: 'Ext Pan ID',
          isBool: true
        },
        {
          key: 'channelPage',
          text: 'Join Attemp',
          isBool: true
        },
        {
          key: 'transmitPower',
          text: 'device.transmit_power',
          isBool: true
        },
        {
          key: 'channelMask',
          text: 'device.channel_mask',
          isBool: true
        },
        {
          key: 'inNetInterval',
          text: 'device.in_net_interval',
          isBool: true
        },
        {
          key: 'devEui',
          text: 'DevEUI',
          isBool: true
        },
        {
          key: 'appEui',
          text: 'AppEUI',
          isBool: true
        },
        {
          key: 'appKey',
          text: 'AppKey',
          isBool: true
        }
      ],
      detailObj: null,
      newDeviceType: {},
      deviceProperty: {},
      detailLoading: false,
      detailIsShow: false,
      detailTitle: '',

      calibrationInfo: {}, // 校准详细对象
      locationList: [], //  位置列表
      groupList: [], // 群组列表
    }
  },
  watch: {
    detailIsShow (newval) {
      this.$emit('update:show', newval)
    }
  },
  methods: {
    detailFn (id, name) {
      // console.log('row===>', row);
      this.detailTitle = `[${name}]` + this.$t('public.details')
      this.detailIsShow = true
      this.detailLoading = true
      sensorGetSensorDetailInfo(id)
        .then(({ result, state }) => {
          this.detailData = result
          result.sensor.pictureBase64 =
            result.sensor.pictureBase64 || result.deviceType.pictureBase64
          this.detailObj = result.sensor
          this.newDeviceType = result.deviceType
          this.deviceProperty = result.deviceProperty || {}
          const { sensor, appConfig, netConfig, deviceAssociate} = result
          // 基本的数据
          sensor.createTime = this.$timetransition(sensor.createTime)
          this.baseMsg.forEach(item => {
            for (const newKey in sensor) {
              item.key === newKey ? (item.content = sensor[newKey]) : null
              if (item.key === 'url') {
                item.content = sensor.fullPath
                  ? `${sensor.fullPath}/${sensor.carrierName}`
                  : `${sensor.scopeName}`
              }
            }
          })

          this.baseMsg.forEach(item => {
            if (item.key === 'location') {
              if (!deviceAssociate) {
                item.content = ''
              } else {
                for (const newKey in deviceAssociate) {
                  item.content = deviceAssociate.location_id
                }
              }
            }
            if (item.key === 'group') {
              if (!deviceAssociate) {
                item.content = ''
              } else {
                for (const newKey in deviceAssociate) {
                  item.content = deviceAssociate.groupId
                }
              }
            }
          })
          this.getGenerValueFn(this.detailRuleObj, appConfig)
          this.getGenerValueFn(this.detailNetObj, netConfig)
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
    getGenerValueFn (array = [], obj) {
      array.forEach(item => {
        item.content = ''
        for (const newKey in obj) {
          item.key === newKey ? (item.content = obj[newKey]) : null
        }
      })
    },
    getCalibration(id){
      getCalibrationInfo(id).then(res => {
        if (res.state.code === 200) {
            this.calibrationInfo = res.result
        }
      })
    },
    getLocation( id){
      getLocationList({deviceCatalog:0,deviceId:id}).then(res => {
        if (res.state.code === 200) {
          this.locationList = res.result
        }
      })
    },
    getGroup(id ){
      getGroupList({deviceCatalog:0,deviceId:id}).then(res => {
        if (res.state.code === 200) {
          this.groupList = res.result
        }
      })
    }
  },
  mounted () {

    // 是否插入到body中
    if (this.appendToBody) {
      this.$nextTick(() => {
        const body = document.querySelector('body')
        if (body.append) {
          body.append(this.$el)
        } else {
          body.appendChild(this.$el)
        }

        document.body.removeChild(this.$el)
        this.$destroy()
      })
    }

    bus.$on('sensorParam', (id, name) => {
      this.detailFn(id, name)
      this.detailIsShow = true

      // 在获取详情的时候直接获取校准信息，再通过父组件传递给校准tab组件
      this.getCalibration(id)
      this.getLocation(id);
      this.getGroup(id);
    })

    // win
    // if (this.$route.query && this.$route.query.id) {
    //     const { id, name } = this.$route.query;
    //     this.detailFn(id, name);
    // }
  },
  beforeDestroy () {
    bus.$off('sensorParam')
  }
}
</script>

<style></style>
